module.exports = __webpack_public_path__ + "img/logo_new2.a1d040e6.png";